import { render, staticRenderFns } from "./NewCompetitorForm.vue?vue&type=template&id=11c16e86&scoped=true&"
import script from "./NewCompetitorForm.vue?vue&type=script&lang=js&"
export * from "./NewCompetitorForm.vue?vue&type=script&lang=js&"
import style0 from "./NewCompetitorForm.vue?vue&type=style&index=0&id=11c16e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c16e86",
  null
  
)

/* custom blocks */
import block0 from "./NewCompetitorForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports